import {
  getCompanyExperiments,
  getExperiments,
  getVisitorPhone,
  getVisitorPhoneVerified
} from './Amalgam';

export const getLandingPage = () => getExperiments().landingPage;
export const getRequestIdentityTime = () => getExperiments().requestIdentityTime;
export const shouldShowMandatoryLogin = () => {
  const landingPage = getLandingPage();

  if (landingPage === 'company-close' && !getVisitorPhone()) {
    return true;
  }

  if (landingPage === 'company-close-otp' && (!getVisitorPhone() || !getVisitorPhoneVerified())) {
    return true;
  }

  return false;
};
export const isSubscriptionEnabled = () => getExperiments().subscriptionEnabled;
export const shouldRemoveCatalogueProductBadges = () =>
  !!getExperiments().removeCatalogueProductBadges;
export const shouldRemoveCatalogueProductPrice = () =>
  !!getExperiments().removeCatalogueProductPrice;
export const shouldRemoveHomeGridAddToList = () =>
  !!(getExperiments().removeCatalogueAddToList || getExperiments().removeHomeGridAddToList);
export const shouldRemoveCatalogueAddToList = () => !!getExperiments().removeCatalogueAddToList;
export const shouldRemoveGalleryAddToList = () => !!getExperiments().removeGalleryAddToList;
export const shouldShowGalleryDoubleTickSendInquiry = () =>
  !!getExperiments().showGalleryDoubleTickSendInquiry;
export const getCompanySelectedLanguage = () =>
  getExperiments().i18n || getCompanyExperiments().i18n || 'en_US';
export const productDownloadEnabled = () => !!getExperiments().enableProductDownload;
export const getImageBackgroundColor = () => getExperiments().imageBackgroundColor;
export const shouldRemoveImageBlurBackground = () => getExperiments().removeBlur;
export const shouldUseImageBackgroundProminentColor = () => getExperiments().useProminentColor;
export const getOrderConfirmationCustomMessage = () =>
  getExperiments().orderConfirmationCustomMessage;
export const getInquiryTextInputPlaceholder = () =>
  getCompanyExperiments().inquiryTextInputPlaceholder;
export const shouldRemoveCompanyNameFromCatalogueHeader = () =>
  getExperiments().removeCompanyNameFromCatalogueHeader;
export const shouldRemoveCompanyContactDetails = () =>
  getExperiments().removeCompanyContactDetailsFromCatalogue;
export const getBulkOrderingKey = () => (getExperiments().bulkOrderingView || {}).id;
export const shouldShowBulkOrderingView = () => !!getBulkOrderingKey();
export const shouldAllCatalogueGridImagesContain = () =>
  getExperiments().allCatalogueGridImagesContain;
export const shouldRemoveSingleCompanyCard = () => getExperiments().removeSingleCompanyCard;
export const shouldRemoveSingleCompanyHeader = () => getExperiments().removeSingleCompanyHeader;
export const isShippingEnabled = () => !!getCompanyExperiments().shippingCost;
export const getGlobalMoqCount = () => getExperiments().minOrderQuantity;
export const getHomeLayout = () => getExperiments().homeLayout;
export const isListView = () => getHomeLayout() === 'list-view';
export const receiveOrderOnWhatsappAllowedByCompany = () => false;
// disabled feature for a moment can be enabled later
// !!getCompanyExperiments().receiveOrderOnWhatsapp;
export const disableAnalytics = () => !!getCompanyExperiments().disableAnalytics;
export const useQueueForFirebaseAnalytics = () =>
  getCompanyExperiments().useQueueForFirebaseAnalytics;
export const getFirebaseAnalyticsViewTimeInterval = () =>
  getExperiments().firebaseAnalyticsViewTimeInterval || 5;
export const shouldShowCouponSections = () => getCompanyExperiments().showCouponSection;
export const shouldShowTaxedPriceOnProductInCatalogueView = () =>
  getExperiments().showTaxedPriceOnProductInCatalogueView;
